import React, { useState, useEffect } from 'react';

import StartView from "./StartView/StartView";



function App() {
  const [config, setConfig]= useState();

  useEffect(() => {
    let url = "./configs/config.json";
    fetch(url)
        .then(res => res.json())
        .then(config => setConfig(config))
    }, []);





  return (
    config!=undefined?
    <div id="mainView" className="app">   
      <StartView config={config}/>
    </div>:null
  );
}

export default App;
